const colors = {
  // Base Colors
  base: {
    white: '#FFFFFF',
    black: '#000000'
  },

  // Gray Scale
  gray: {
    25: '#FCFCFD',
    50: '#F9FAFB',
    75: '#F2F4F7',
    100: '#EAECF0',
    200: '#DEE3EA',
    300: '#D0D5DD',
    400: '#98A2B3',
    500: '#667085',
    600: '#475467',
    700: '#344054',
    800: '#182230',
    900: '#1A2022',
    950: '#0E1112'
  },

  // CIC Blue
  cic: {
    blue: {
      25: '#F8FDFF',
      50: '#F2FAFF',
      100: '#D6EEFF',
      200: '#A8DBFF',
      300: '#7AC7FF',
      400: '#4DB3FF',
      500: '#0596FF',
      600: '#007FE0',
      700: '#0066B8',
      800: '#004C8F',
      900: '#003366',
      950: '#001A33'
    },

    // CIC Mint
    mint: {
      25: '#F6FEFC',
      50: '#F0FDF9',
      100: '#CCFBEF',
      200: '#99F6E0',
      300: '#5FE9D0',
      400: '#2ED3B7',
      500: '#15B79E',
      600: '#0E9384',
      700: '#107569',
      800: '#125D56',
      900: '#134E48',
      950: '#0A2926'
    },

    // CIC Pink
    pink: {
      25: '#FEF6FB',
      50: '#FDF2FA',
      100: '#FCE7F6',
      200: '#FCCEEE',
      300: '#FAA7E0',
      400: '#F670C7',
      500: '#EE46BC',
      600: '#DD2590',
      700: '#C11574',
      800: '#9E165F',
      900: '#851651',
      950: '#4E0D30'
    }
  },

  // Success
  success: {
    25: '#F6FEF9',
    50: '#ECFDF3',
    100: '#DCFAE6',
    200: '#A9EFC5',
    300: '#75E0A7',
    400: '#47CD89',
    500: '#17B26A',
    600: '#079455',
    700: '#067647',
    800: '#085D3A',
    900: '#074D31',
    950: '#053321'
  },

  // Error
  error: {
    25: '#FFFBFA',
    50: '#FEF3F2',
    100: '#FEE4E2',
    200: '#FECDCA',
    300: '#FDA29B',
    400: '#F97066',
    500: '#F04438',
    600: '#D92D20',
    700: '#B42318',
    800: '#912018',
    900: '#7A271A',
    950: '#55160C'
  },

  // Warning
  warning: {
    25: '#FFFCF5',
    50: '#FFFAEB',
    100: '#FEF0C7',
    200: '#FEDF89',
    300: '#FEC84B',
    400: '#FDB022',
    500: '#F79009',
    600: '#DC6803',
    700: '#B54708',
    800: '#93370D',
    900: '#7A2E0E',
    950: '#4E1D09'
  },

  // Gray Blue
  'gray-blue': {
    25: '#FCFCFD',
    50: '#F8F9FC',
    100: '#EAECF5',
    200: '#D5D9EB',
    300: '#B3B8DB',
    400: '#717BBC',
    500: '#4E5BA6',
    600: '#3E4784',
    700: '#363F72',
    800: '#293056',
    900: '#101323',
    950: '#0D0F1C'
  },

  // Indigo
  indigo: {
    25: '#F5F8FF',
    50: '#EEF4FF',
    100: '#E0EAFF',
    200: '#C7D7FE',
    300: '#A4BCFD',
    400: '#8098F9',
    500: '#6172F3',
    600: '#444CE7',
    700: '#3538CD',
    800: '#2D31A6',
    900: '#2D3282',
    950: '#1F235B'
  },

  // Purple
  purple: {
    25: '#FAFAFF',
    50: '#F4F3FF',
    100: '#EBE9FE',
    200: '#D9D6FE',
    300: '#BDB4FE',
    400: '#9B8AFB',
    500: '#7A5AF8',
    600: '#6938EF',
    700: '#5925DC',
    800: '#4A1FB8',
    900: '#3E1C96',
    950: '#27115F'
  },

  // Orange
  orange: {
    25: '#FEFAF5',
    50: '#FEF6EE',
    100: '#FDEAD7',
    200: '#F9DBAF',
    300: '#F7B27A',
    400: '#F38744',
    500: '#EF6820',
    600: '#E04F16',
    700: '#B93815',
    800: '#932F19',
    900: '#772917',
    950: '#511C10'
  }
};

export default colors;
